import { createActions, createReducer } from "reduxsauce"
import { call, put, takeLatest, select, getContext } from "redux-saga/effects"
import { get } from "lodash"
import { put as apiPut } from "api"
import { Creators as notificationCreators } from "modules/notifications/model"

export const { Types, Creators } = createActions({
  activateUser: ["token"],
}, {
  prefix: "ompnt/modules/userActivation",
})

const DEFAULT_STATE = {}

export default createReducer(DEFAULT_STATE, {})

function* activateUser({ token }) {
  const { account } = yield select(state => ({
    account: get(state, "global.selected.account"),
  }))

  try {
    yield call(apiPut, `/api/${account}/user-activation/${token}`)
    yield put(notificationCreators.add("success", null, "User successfully activated."))
  } catch {
    yield put(notificationCreators.add("error", null, "An error occured while activating the user."))
  }
  const { navigate } = yield getContext("router")
  yield call(navigate, `/${account}/home/members`)
}

export function* saga() {
  yield takeLatest(Types.ACTIVATE_USER, activateUser)
}
